import { SeoLandingTemplate } from "@/components/seo/seo-landing-template";
import {
	AI_TEAMMATES_EXTERNAL_LINKS,
	AI_TEAMMATES_FAQ_ITEMS,
	AI_TEAMMATES_H1,
	AI_TEAMMATES_INTERNAL_LINKS,
	AI_TEAMMATES_INTRO_PARAGRAPHS,
	AI_TEAMMATES_OUTLINE,
	AI_TEAMMATES_SECTIONS,
} from "@/constants/seo/ai-teammates-content";
import { AI_TEAMMATES_LANDING_UI } from "@/constants/seo/seo-landing-ui";

export function AiTeammatesPage() {
	return (
		<SeoLandingTemplate
			ui={AI_TEAMMATES_LANDING_UI}
			h1={AI_TEAMMATES_H1}
			introParagraphs={AI_TEAMMATES_INTRO_PARAGRAPHS}
			outline={AI_TEAMMATES_OUTLINE}
			sections={AI_TEAMMATES_SECTIONS}
			internalLinks={AI_TEAMMATES_INTERNAL_LINKS}
			externalLinks={AI_TEAMMATES_EXTERNAL_LINKS}
			faqItems={AI_TEAMMATES_FAQ_ITEMS}
		/>
	);
}
